import React, { useState } from 'react';
import { reportingService } from '../../services/reportingService';
import { useLanguage } from '../../contexts/LanguageContext';
import { Activity, BarChart3, Calendar, DollarSign, Filter, Users, Zap } from 'lucide-react';

const ReportGenerator = ({ onReportGenerated, loading, setLoading }) => {
    const [reportType, setReportType] = useState('users');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const { t } = useLanguage();

    const handleGenerateReport = async (e) => {
        e.preventDefault();
        if (!startDate || !endDate) {
            alert('Lütfen tarih aralığı seçin');
            return;
        }

        setLoading(true);
        try {
            const response = await reportingService.createCustomReport(reportType, startDate, endDate);
            if (response.success) {
                onReportGenerated(response.data);
            }
        } catch (error) {
            console.error('Rapor oluşturulurken hata:', error);
        } finally {
            setLoading(false);
        }
    };

    const quickRanges = reportingService.getQuickDateRanges();

    const setQuickRange = (rangeKey) => {
        const range = quickRanges[rangeKey];
        setStartDate(range.start);
        setEndDate(range.end);
    };

    return (
        <div className="report-generator-card">
            <div className="generator-header">
                <div className="header-icon">
                    <BarChart3 size={28} />
                </div>
                <div className="header-content">
                    <h2>{t('reportingCustomReport')}</h2>
                    <p>{t('reportingModuleDesc')}</p>
                </div>
            </div>

            <form onSubmit={handleGenerateReport} className="generator-form">
                <div className="form-section">
                    <div className="section-header">
                        <Filter size={20} />
                        <h3>{t('reportingTypeSelection')}</h3>
                    </div>
                    <div className="type-grid">
                        <div className="type-option">
                            <input
                                type="radio"
                                id="users"
                                name="reportType"
                                value="users"
                                checked={reportType === 'users'}
                                onChange={(e) => setReportType(e.target.value)}
                            />
                            <label htmlFor="users">
                                <Users size={20} />
                                <span>{t('reportingUserReports')}</span>
                                <small>Kullanıcı büyüme ve dağılım analizi</small>
                            </label>
                        </div>
                        <div className="type-option">
                            <input
                                type="radio"
                                id="revenue"
                                name="reportType"
                                value="revenue"
                                checked={reportType === 'revenue'}
                                onChange={(e) => setReportType(e.target.value)}
                            />
                            <label htmlFor="revenue">
                                <DollarSign size={20} />
                                <span>{t('reportingRevenueReports')}</span>
                                <small>Gelir ve ödeme istatistikleri</small>
                            </label>
                        </div>
                        <div className="type-option">
                            <input
                                type="radio"
                                id="usage"
                                name="reportType"
                                value="usage"
                                checked={reportType === 'usage'}
                                onChange={(e) => setReportType(e.target.value)}
                            />
                            <label htmlFor="usage">
                                <Activity size={20} />
                                <span>{t('reportingUsageReports')}</span>
                                <small>Kullanım ve performans metrikleri</small>
                            </label>
                        </div>
                    </div>
                </div>

                <div className="form-section">
                    <div className="section-header">
                        <Calendar size={20} />
                        <h3>{t('reportingDateSelection')}</h3>
                    </div>

                    <div className="quick-selection">
                        <span>{t('reportingQuickSelect')}:</span>
                        <div className="quick-buttons">
                            <button type="button" onClick={() => setQuickRange('last7Days')}>
                                {t('reportingLast7Days')}
                            </button>
                            <button type="button" onClick={() => setQuickRange('last30Days')}>
                                {t('reportingLast30Days')}
                            </button>
                            <button type="button" onClick={() => setQuickRange('last90Days')}>
                                {t('reportingLast90Days')}
                            </button>
                            <button type="button" onClick={() => setQuickRange('thisMonth')}>
                                {t('reportingThisMonth')}
                            </button>
                        </div>
                    </div>

                    <div className="date-inputs">
                        <div className="input-group">
                            <label htmlFor="startDate">{t('reportingStartDate')}</label>
                            <input
                                type="date"
                                id="startDate"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                required
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="endDate">{t('reportingEndDate')}</label>
                            <input
                                type="date"
                                id="endDate"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                required
                            />
                        </div>
                    </div>
                </div>

                <button
                    type="submit"
                    className="generate-button"
                    disabled={loading}
                >
                    <Zap size={18} />
                    {loading ? t('reportingGeneratingStatus') : t('reportingGenerateAction')}
                </button>
            </form>
        </div>
    );
};

export default ReportGenerator;